(function() {
    'use strict';

    angular.module("product")
        .controller('ProductOptionPricesInQuantityUpdate', ProductOptionPricesInQuantityUpdate);

    ProductOptionPricesInQuantityUpdate.$inject = ['currentQuantity', 'product', 'options', '$uibModalInstance', 'productOptionPricesDataSrvc', 'lodashService', 'productoptionpricePermissionsConst'];

    function ProductOptionPricesInQuantityUpdate(currentQuantity, product, options, $uibModalInstance, productOptionPricesDataSrvc, lodashService, productoptionpricePermissionsConst) {
        var self = this;

        var selected_options = lodashService.flatten(product.group_options.map(function(group) {
            return group.options;
        }));

        self.optionRows = selected_options.map(function(item) {
            var price = lodashService.find(product.option_prices, function(price) {
                return price.product === product.pk &&
                    price.product_option === item.option &&
                    price.product_quantity === currentQuantity.pk;
            });

            var option_obj = lodashService.find(options, function(opt) {
                return opt.pk === item.option;
            });

            return {
                option: option_obj.label,
                price: price ? parseFloat(price.price) : 0,
                pk: item.option
            };
        });
        self.optionCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            isEditable: false
        }, {
            title: 'Opcja',
            value: 'option',
            type: 'number',
            isEditable: false
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true
        }];
        self.modelPermissions = productoptionpricePermissionsConst;

        self.ok = ok;
        self.onOptionEdit = onOptionEdit;

        function ok() {
            $uibModalInstance.close();
        }

        function onOptionEdit(row) {
            var callback = productOptionPricesDataSrvc.priceDetail({}, {
                product_option: row.pk,
                product_quantity: currentQuantity.pk,
                product: product.pk,
                price: row.price
            });

            callback.$promise.then(
                function(response) {
                    product.option_prices = response;
                }
            );

            return callback;
        }
    }
})();
